import { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { useSite } from "@/lib/site";
import { api } from "@/lib/api";
import { Monogram, Wordmark } from "@/components/site/Logo";

const Tab = ({ to, children, testid, end, active }) => (
  <NavLink to={to} end={end} data-testid={testid}
           className={({ isActive }) => `whitespace-nowrap border-b-2 px-1 py-3 text-[15px] font-semibold transition-colors duration-150 ${(active ?? isActive) ? "border-brand-red text-slate-900" : "border-transparent text-slate-600 hover:text-slate-900"}`}>
    {children}
  </NavLink>
);

export default function DealerLayout() {
  const { user, logout } = useAuth();
  const { cfg } = useSite();
  const loc = useLocation();
  const [sum, setSum] = useState(null);
  useEffect(() => { api.get("/dealer/summary").then((r) => setSum(r.data)).catch(() => {}); }, [loc.pathname]);
  const p = loc.pathname;
  const onEnquiries = p === "/dealer" || p === "/dealer/test" || p.startsWith("/dealer/enquiries");
  return (
    <div className="min-h-screen bg-brand-offwhite">
      <header className="border-b border-border bg-white">
        <div className="mx-auto flex max-w-5xl items-center justify-between gap-3 px-4 pt-3 sm:px-6">
          <div className="flex items-center gap-2.5">
            <Monogram className="hidden h-9 w-9 sm:block" />
            <div>
              <Wordmark className="text-lg leading-none" />
              <p className="mt-1.5 text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-500">Dealer dashboard</p>
            </div>
          </div>
          <div className="flex items-center gap-3 text-sm">
            {cfg.valuation.mode === "sandbox" && <span className="hidden rounded border border-amber-400 bg-amber-50 px-2 py-1 text-xs font-semibold text-amber-900 sm:inline" data-testid="dealer-sandbox-badge">Sandbox valuations</span>}
            <span className="hidden text-slate-600 md:inline" data-testid="dealer-user-email">{user.email}</span>
            <button onClick={logout} className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-slate-300 px-3 py-2 font-medium hover:bg-slate-50" data-testid="logout-button"><LogOut className="h-4 w-4" />Sign out</button>
          </div>
        </div>
        <nav className="mx-auto flex max-w-5xl gap-6 overflow-x-auto px-4 sm:px-6" aria-label="Dashboard">
          <Tab to="/dealer" end active={onEnquiries} testid="dealer-nav-enquiries">
            Enquiries {sum?.new ? <span className="ml-1 rounded-full bg-brand-red px-1.5 py-0.5 text-[11px] text-white" data-testid="nav-unseen-count">{sum.new}</span> : null}
          </Tab>
          <Tab to="/dealer/settings" testid="dealer-nav-settings">Settings</Tab>
          <a href="/" className="ml-auto whitespace-nowrap px-1 py-3 text-sm font-medium text-slate-500 hover:text-slate-900" data-testid="dealer-nav-view-site">View website</a>
        </nav>
      </header>
      <main className="mx-auto max-w-5xl px-4 py-6 sm:px-6 sm:py-8"><Outlet context={{ summary: sum }} /></main>
    </div>
  );
}
